import { GetResponse } from '~/features/vault/licenses/utils/types';
import { CDSLicense, CombinedLicense, DEALicense, MedicalLicense } from '~/types';
import { CombinedLicenseResponse } from './types';

export const cdsApiToCombinedLicenses = (licensesStr: string): CombinedLicenseResponse => {
  const response: GetResponse<CDSLicense> = JSON.parse(licensesStr);
  return {
    ...response,
    data: response.data.map((license) =>
      cdsToCombinedLicense(JSON.stringify(license))
    ) as CombinedLicense[],
  };
};

export const cdsToCombinedLicense = (licenseStr: string): CombinedLicense => {
  const license: CDSLicense = JSON.parse(licenseStr);
  return {
    id: license.id,
    licenseType: 'CDS',
    expiryDate: license.expiryDate,
    stateCode: license.issuingStateCode,
    status: license.activeFlag ? 'Active' : 'Inactive',
    keyPrefix: 'CDS-',
    licenseNumber: license.licenseNum,
  };
};

export const deaApiToCombinedLicenses = (licensesStr: string): CombinedLicenseResponse => {
  const response: GetResponse<DEALicense> = JSON.parse(licensesStr);
  return {
    ...response,
    data: response.data.map((license) =>
      deaToCombinedLicense(JSON.stringify(license))
    ) as CombinedLicense[],
  };
};

export const deaToCombinedLicense = (licenseStr: string): CombinedLicense => {
  const license: DEALicense = JSON.parse(licenseStr);
  return {
    id: license.id,
    licenseType: 'DEA',
    expiryDate: license.expiryDate,
    stateCode: '--',
    status: license.activeFlag ? 'Active' : 'Inactive',
    keyPrefix: 'DEA-',
    licenseNumber: license.deaNum,
  };
};

export const medicalLicenseApiToCombinedLicense = (
  licensesStr: string
): CombinedLicenseResponse => {
  const licenses: MedicalLicense[] = JSON.parse(licensesStr);
  return {
    data: licenses.map((license) =>
      medicalLicenseToCombinedLicense(JSON.stringify(license))
    ) as CombinedLicense[],
    page: 1,
    pageSize: licenses.length,
    total: licenses.length,
  };
};

export const medicalLicenseToCombinedLicense = (licenseStr: string): CombinedLicense => {
  const license: MedicalLicense = JSON.parse(licenseStr);
  return {
    id: license.id,
    licenseType: license.licenseType || 'MEDICAL',
    expiryDate: license.expiryDate,
    stateCode: license.stateCode || 'NA',
    status: license.currStatus,
    keyPrefix: 'MED-',
    licenseNumber: license.licenseNumber,
  };
};
